import * as React from 'react';
import { AudioButton, AudioRecorderUseMode } from '../../../_components/AudioRecorder/AbstractAudioView';
import { RecordingState } from '../../../_components/AudioRecorder/MediaRecorder';
// import { AudioButton, AudioRecorderUseMode, RecordingState } from '../../../_components/AudioRecorder';
import { colors } from '../../../styles/colors';
import { getRoundAudioButtonStyle, startStopButtonStyle } from './AudioStyles';

export function createStopButton(size: number): AudioButton {
    const outerButtonStyle = getRoundAudioButtonStyle(size);
    const innerButtonStyle = getRoundAudioButtonStyle((size = 18));
    return ({ recordingState, mode, playbackState, style, ...props }) => {
        if (mode === AudioRecorderUseMode.Recording && recordingState === RecordingState.Recording) {
            return (
                <div {...props} style={{ ...style, ...outerButtonStyle, ...startStopButtonStyle }}>
                    <div style={{ ...innerButtonStyle, ...innerStyle }} />
                </div>
            );
        }
        return null;
    };
}

const innerStyle: React.CSSProperties = {
    borderRadius: 3,
    backgroundColor: colors.CANCEL_TEXT
};



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/Audio/StopButton.tsx